<div class="footer" *ngIf="loggedInUser" [style.background-color]='getColor()'>
 <p>
     Copyright &#169; 2023
 </p>
</div>